module.exports = __webpack_public_path__ + "img/user-dummy-img3.b574ef21.png";